import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import ServiceOrderLoader from '../resumeV2/_load/ServiceOrderLoader'
import ChildrenServiceOrderLoader from '../resumeV2/_load/ChildrenServiceOrderLoader'

const ServiceOrdersPdfPage = ({ id }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <ChildrenServiceOrderLoader parentId={id}>
          <PageHeader />
          <PageContent />
        </ChildrenServiceOrderLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default ServiceOrdersPdfPage
